export enum Flags {
  DischargeQuestions = 'discharge_questions',
  ImportImprovements = 'import_improvements',
  AltcsPending = 'altcs_pending',
  Insights = 'insights',
  UmEnhancements = 'um_enhancements',
  ComparisonForAiSummary = 'comparison_for_ai_summary',
  InboundReferrals = 'inbound_referrals',
}
